import DeleteSvg from '@/shared/assets/images/Trash.svg'
import { useAppDispatch, useAppSelector } from '@/shared/lib/redux'
import { fetchApiKey, selectApiKey } from '../../model'
import { useUpdateApiKeyModal } from '@/features/update-api-key'

export const RecreateApiKey = () => {
    const { openRecreateApiKeyModal } = useUpdateApiKeyModal()
    const apiKey = useAppSelector(selectApiKey)
    const dispatch = useAppDispatch()

    const onRecreate = () => {
        dispatch(fetchApiKey())
    }

    return (
        <button onClick={() => openRecreateApiKeyModal(apiKey, onRecreate)}>
            <DeleteSvg width={20} height={20} />
        </button>
    )
}